export default [{
	title: 'Licitaciones',
	icon: 'BookmarkIcon',
	children: [
		{
			title: 'Lista',
			route: 'tenders-list',
			action: 'read',
			resource: 'tenders'
		},
		{
			title: 'Invitaciones',
			route: 'tenders-invitations',
			action: 'read',
			resource: 'invitations'
		},
	]
}];